import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import CustomDataTable from '../../../../Components/CustomTable/CustomTable';
import { Triangle } from 'react-loader-spinner';
import { RestroUserLogData } from '../../../../services/DatabaseService/RestroUserLogData';
import { formatDateTime } from '../../../../Components/Common/FormatDate';

const LogsDetails = () => {
    const { apiKey } = useParams();
    const [loading, setLoading] = useState(false)
    const [logData, setLogData] = useState([null]);
      const [dataList, setDataList] = useState([]);
    
    useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          try {
            const result= await RestroUserLogData.getByApiKey(apiKey);
            setLogData(result);
            setDataList(result || []);
          } catch (error) {
            console.error("Error fetching data", error);
          } finally {
            setLoading(false);
          }
        };
        fetchData();
      }, [apiKey]);

    const [activeTab, setActiveTab] = useState("1");
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
          }
        };
      
    const [filterText, setFilterText] = useState("");

    const filteredData = dataList.filter(
    (item) =>
      (item.name?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      ) ||
      (item.database?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      )
  );

    const handleFilterChange = (e) => {
        setFilterText(e.target.value);
    };

    const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
        width: "max-content",
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const columns = [
      {
        name: "S No",
        selector: (row, index) => index + 1,
        width: "90px",
        sortable: true,
      },
      {
        name: "Log In Time",
        selector: (row) => formatDateTime(row.logTime),
        width: "275px",
        sortable: true,
      },
      {
        name: "Log For",
        selector: (row) => row.logFor,
        width: "175px",
        sortable: true,
      },
      {
        name: "Detail",
        selector: (row) => <span title={row.logDetails}>{row.logDetails}</span>,
        // width: "280px",
        sortable: true,
      },
      {
        name: "status",
        selector: (row) => row.status,
        sortable: true,
        width: "125px",
        cell: (row) => (
          <span
            className={`badge ${row.status ? "bg-success" : "bg-danger"}`}
          // onClick={() => console.log("Button clicked for", row)}
          >
            {row.status ? "Success" : "Faliure"}
          </span>
        ),
      },
      // {
      //   name: "Action",
      //   selector: (row) => (
      //     <div>
      //       <Button
      //         color="btn btn-soft-warning"
      //         className="btn-sm ms-1"
      //         // onClick={() => {
      //         //   setAddModal(true);
      //         //   // setSelectedCustomer(row);
      //         // }}
      //       >
      //         <i className="ri-edit-line" />
      //       </Button>
      //       <Button
      //         className="btn btn-soft-danger btn-sm ms-1"
      //         color="danger"
      //         // onClick={() => handleDeleteClick(row.id)}
      //       >
      //         <i className="ri-delete-bin-5-line" />
      //       </Button>
      //     </div>
      //   ),
      //   center: true,
      // },
    ];
  
  return (
    <div className='page-content py-0'>
        <div className='container-fluid px-0'>
            <Card className="d-none d-md-block d-lg-block mx-0 ">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-md-none d-lg-none mt-2"
            >
              <CardBody >
                <Row>
                  <Col xs={10}>
                    <h6 className="mb-2">
                      <strong>S No:</strong> {index + 1}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Log In Time :</strong> {item.logTime}
                    </h6>
                    
                    <h6 className="mb-2">
                      <strong>Log For:</strong> {item.logFor}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Detail:</strong> {item.logDetails}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Status:</strong> {item.status}
                    </h6>
                    {item.status ? (
                      <button
                        className="btn btn-success px-1 px-sm-2"
                        onClick={() => setAddModal(true)}
                      >
                        Active
                      </button>
                    ) : (
                      <button
                        className="btn btn-danger px-1 px-sm-2"
                        onClick={() => setAddModal(true)}
                      >
                        InActive
                      </button>
                    )}
                  </Col>
                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation();
                          setDataList((prev) =>
                            prev.map((dbItem) =>
                              dbItem.id === item.id
                                ? {
                                  ...dbItem,
                                  dropdownOpen: !dbItem.dropdownOpen,
                                }
                                : { ...dbItem, dropdownOpen: false }
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() => {
                              setAddModal(true);
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem>
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
      {/* <ContactPersonForm
        modalOpen = {contactModalOpen}
        toggleModal = {toggleContactModal}
      /> */}
        </div>
      
    </div>
  )
}

export default LogsDetails
